<template>
  <el-select v-model="value" placeholder="All" @update:modelValue="update">
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  FlatDealType,
  FlatDealTypeLabel,
  FlatDealTypeLabels
} from '@/api/types'

type FlatDealEntry = {
  key: string
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'FlatDealTypeSelect',
  props: {
    modelValue: {
      type: String,
      default: undefined
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = FlatDealTypeLabels.map<FlatDealEntry>(
      (deviceLabel: FlatDealTypeLabel) => {
        return {
          key: deviceLabel.type_id.toString(),
          label: deviceLabel.label,
          disabled: false
        }
      }
    )

    const update = (newValue: FlatDealType) => {
      context.emit('update:modelValue', newValue.toString())
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { options, update, value }
  }
})
</script>
